export const irrigationSystemDefaults = {
  sprinkler: {
    system: "sprinkler",
    number: "8",
    s_rate: "1000",
  },
  drip: {
    system: "drip",
    number_driping_pipes: "1",
    space_driping_bores: "30",
    d_rate: "3",
    wetted_length: "2000",
  },
  subterranean: {
    system: "subterranean",
    depth_pipes: "20",
    number_driping_pipes: "2",
    spacing_dripping_bore: "60",
    d_rate: "4",
    wetted_length: "2000",
  },
  "surface irrigation": {
    system: "surface irrigation",
    surface_irrigation_rate: "5",
  },
};

export const fieldInitialValues = {
  id: null,
  name: "",
  weather_station: "",

  polygons: [
    { id: null, position: [], color: "blue", popup: null, tooltip: null },
  ],
  irrigations_system: {
    system: "subterranean",
    depth_pipes: "20",
    number_driping_pipes: "2",
    spacing_dripping_bore: "60",
    d_rate: "2",
    wetted_length: "2000",
  },
  soil_type: {
    clay: "20",
    silt: "50",
    sand: "30",
    field_capacity: "27",
    permanent_wilting_point: "10",
    bulk_density: "1.4",
    soil_porosity: "40",
    water_content_saturation: "40",
    water_content_saturation_by_sensor: "45",
    saturated_hydraulic_conductivity: "2.78",
    organic_matter: "0",
    climate_zone: "mediterranean",
  },
  crop: {
    type: "perennial",
    species: "citrus",
    variety_name: "",
    variety_code: "",
    distance_line: "300",
    distance_individuals: "200",
    planting_date: "",
    flowering_date: "",
    rieping_date: "",
    expected_harvest_date: "",
    real_harvest_date: "",
    crop_yields: "",
    planting_year: "",
  },
  sensors: [],
  activities: {
    irrigation: [],
    soil_preparation: [],
    fertilizer: [],
    pesticide: [],
  },
  realtime: {
    irrigation_profile: {},
    transpiration_profile: {},
    suggested_irrigation: {},
    sensors_data: [],
  },
};

export const irrigationSystem = {
  sprinkler: "sprinkler",
  drip: "drip",
  subterranean: "subterranean",
  surface_irrigation: "surface",
};

export const soilType = {
  texture: "texture",
  field_capacity: "field_capacity",
  permanent_wilting_point: "permanent_wilting_point",
  bulk_density: "bulk_density",
  soil_porosity: "soil_porosity",
  climate_zone: "climate_zone",
  water_content_saturation: "water_content_saturation",
  water_content_saturation_by_sensor: "water_content_saturation_by_sensor",
  saturated_hydraulic_conductivity: "saturated_hydraulic_conductivity",
  organic_matter: "organic_matter",
};

export const cropType = {
  annual: "annual",
  perennial: "perennial",
};

export const speciesType = {
  tomato: {
    crop: "tomato",
    type: 1,
  },
  maize: {
    crop: "maize",
    type: 1,
  },
  potato: {
    crop: "potato",
    type: 1,
  },
  onion: {
    crop: "onion",
    type: 1,
  },
  wheat: {
    crop: "wheat",
    type: 1,
  },
  rice: {
    crop: "rice",
    type: 1,
  },
  barley: {
    crop: "barley",
    type: 1,
  },
  sorghum: {
    crop: "sorghum",
    type: 1,
  },
  soybean: {
    crop: "soybean",
    type: 1,
  },
  sunflower: {
    crop: "sunflower",
    type: 1,
  },
  lettuce: {
    crop: "lettuce",
    type: 1,
  },
  carrot: {
    crop: "carrot",
    type: 1,
  },
  watermelon: {
    crop: "watermelon",
    type: 1,
  },
  citrus: {
    crop: "citrus",
    type: 2,
  },
  almond: {
    crop: "almond",
    type: 2,
  },
  date_palm: {
    crop: "date palm",
    type: 2,
  },
  peach: {
    crop: "peach",
    type: 2,
  },
  wine_grapes: {
    crop: "wine grapes",
    type: 2,
  },
  olives: {
    crop: "olives",
    type: 2,
  },
  cotton: {
    crop: "cotton",
    type: 1,
  },
  alfalfa: {
    crop: "alfalfa",
    type: 2,
  },
  pastures: {
    crop: "pastures",
    type: 2,
  },
  cauliflower: {
    crop: "cauliflower",
    type: 1,
  },
  eggplant: {
    crop: "eggplant",
    type: 1,
  },
  cucumber: {
    crop: "cucumber",
    type: 1,
  },
  guava: {
    crop: "guava",
    type: 1,
  },
  banana: {
    crop: "banana",
    type: 2,
  },
  fava_bean: {
    crop: "fava bean",
    type: 1,
  },
  sugar_beet: {
    crop: "sugar beet",
    type: 1,
  },
  bean: {
    crop: "bean",
    type: 1,
  },
  vetch: {
    crop: "vetch",
    type: 1,
  },
  radish: {
    crop: "radish",
    type: 1,
  },
  onion_dry: {
    crop: "onion dry",
    type: 1,
  },
  artichoke: {
    crop: "artichoke",
    type: 2,
  },
  melon: {
    crop: "melon",
    type: 1,
  },
};

export const cropAnnualKeys = [
  "type",
  "species",
  "variety_name",
  "variety_code",
  "distance_line",
  "distance_individuals",
  "planting_date",
  "flowering_date",
  "rieping_date",
  "expected_harvest_date",
  "real_harvest_date",
  "crop_yields",
];

export const cropPerennialKeys = [
  "type",
  "species",
  "variety_name",
  "variety_code",
  "distance_line",
  "distance_individuals",
  "planting_year",
  "flowering_date",
  "rieping_date",
  "expected_harvest_date",
  "real_harvest_date",
  "crop_yields",
];

export const soilTypeKeys = [
  "clay",
  "silt",
  "sand",
  "field_capacity",
  "permanent_wilting_point",
  "bulk_density",
  "soil_porosity",
  "water_content_saturation",
  "water_content_saturation_by_sensor",
  "saturated_hydraulic_conductivity",
  "organic_matter",
];

export const irrigationsSystemKeys = ["system"];

export const irrigationsSystemSprinklerKeys = ["system", "number", "s_rate"];

export const irrigationsSystemDriprKeys = [
  "system",
  "number_driping_pipes",
  "space_driping_bores",
  "d_rate",
  "wetted_length",
];

export const irrigationsSystemSubterraneanKeys = [
  "system",
  "depth_pipes",
  "number_driping_pipes",
  "spacing_dripping_bore",
  "d_rate",
  "wetted_length",
];

export const irrigationsSystemSurfaceIrrigationKeys = [
  "system",
  "surface_irrigation_rate",
];
